namespace Dashboard {

    class DashboardCarousel {
        itemlist: any[];
        onCarouselChange: (x: {index: number}) => void;
        itemClick: (x: { item: any }) => void;
        itemPartial: string;
        formatItem: (x: { item: any }) => void;

        selected:number = 0;
        carousel: any;
        prev: JQuery;
        next: JQuery;
        scope: ng.IScope;

        init(scope: ng.IScope, carousel: any, prev: JQuery, next: JQuery) {
            this.carousel = carousel;
            this.scope = scope;
            this.prev = prev;
            this.next = next;
        }

        initCarousel() {
            this.carousel.slick({
                    prevArrow: this.prev,
                    nextArrow: this.next,
                    infinite: false
                });
            this.carousel.on('beforeChange', (event, slick, currentSlide, nextSlide) =>{
                        this.selected = nextSlide;
                        this.onCarouselChange({index:nextSlide});
                        this.scope.$apply();
            });
            this.scope.$on('$destroy', () => {
                this.carousel.off('beforeChange');
            });
        }

        formatedItem = (item) => this.formatItem({ item: item });

        onItemClick = (item)=> {this.itemClick({item:item});};
    }

    angular
    .module('dashboard')
    .directive('dashboardCarousel', (): ng.IDirective => {

        return {
            scope: {},
            bindToController: {
                itemlist: '=',
                onCarouselChange: '&',
                itemClick: '&',
                itemPartial: '=',
                formatItem: '&'
            },
            controller: DashboardCarousel,
            controllerAs: 'dc',
            templateUrl: (el : ng.IAugmentedJQuery, attrs) => {
                if (attrs.itemPartial) {
                    return 'partials/dashboard/DashboardCarousel?itemPartial=' + attrs.itemPartial;
                }
                return 'partials/dashboard/DashboardCarousel';
            } ,

            link:  (scope : ng.IScope, el : ng.IAugmentedJQuery, attr, controller : DashboardCarousel) => {
                controller.init(scope, $('.dashboard-carousel'), $('#arrow-prev'), $('#arrow-next'));
            }

        };

    }).directive('carouselItem', ($timeout) => {
        return {
            restrict: 'A',
            transclude: false,
            require: '^dashboardCarousel',
            link: (scope: ng.IScope, el : ng.IAugmentedJQuery, attr, controller : DashboardCarousel) => {
                // wait for the last item in the ng-repeat then call init
                if (scope.$last) {
                    $timeout( ()=> {
                        controller.initCarousel();
                    });
                }
            }
        };
    });
}
